import config from "../config.json";
import http from "./httpService";
const apiEndpoint = config.apiEndpoint + "auth/";
const tokenKey = "user";

http.setJwt(getToken());

export async function login(email, password) {
  const result = await http.post(apiEndpoint + "login", {
    username: email,
    password: password
  });
  if (result.data.isOk) {
    localStorage.setItem(tokenKey, JSON.stringify(result.data.user));
    http.setJwt(getToken());
  }
  return result.data;
}
export async function loginWithJwt(user) {
  localStorage.setItem(tokenKey, JSON.stringify(user));
  http.setJwt(getToken());
}
export function logout() {
  localStorage.removeItem(tokenKey);
}
export function getCurrentUser() {
  try {
    return JSON.parse(localStorage.getItem(tokenKey));
  } catch (error) {
    console.error(error);
    return null;
  }
}

export function IsAdmin() {
  try {
    const user = getCurrentUser();
    if (user && user.role === "Administrator") return true;
    else return false;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function register(user) {
  const result = await http.post(apiEndpoint + "register", {
    username: user.username,
    password: user.password,
    fullName: user.fullname,
    company: user.company
  });
  return result.data;
}
export function getToken() {
  const token = localStorage.getItem(tokenKey);
  if (token) {
    return JSON.parse(localStorage.getItem(tokenKey)).token;
  } else {
    return token;
  }

  //return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxIiwidXNlck5hbWUiOiJiYWwiLCJuYmYiOjE1NzAyMDQ2OTcsImV4cCI6MTU3MDgwOTQ5NywiaWF0IjoxNTcwMjA0Njk3fQ.FHgqLsvkUCfJ189U3VtkBqEZk9NUqekpCdrWMnj7FuA";
}
export async function forgotPassword(username) {
  const result = await http.post(apiEndpoint + "forgetpassword", {
    username: username
  });
  return result.data;
}
export async function resetPassword(hash, password) {
  const result = await http.post(apiEndpoint + "resetpassword", {
    forgetPasswordToken: hash,
    newPassword: password
  });
  if (result.data.isOk) {
    localStorage.setItem(tokenKey, JSON.stringify(result.data.user));
    http.setJwt(getToken());
  }
  return result.data;
}
export async function deleteUser(userId) {
  const result = await http.delete(config.apiEndpoint + "users/" + userId);
  return result.data;
}
export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  register,
  forgotPassword,
  resetPassword,
  getToken,
  IsAdmin,
  deleteUser
};
